import { render, staticRenderFns } from "./imageDialog.vue?vue&type=template&id=60c0c516&scoped=true"
import script from "./imageDialog.vue?vue&type=script&lang=js"
export * from "./imageDialog.vue?vue&type=script&lang=js"
import style0 from "./imageDialog.vue?vue&type=style&index=0&id=60c0c516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0c516",
  null
  
)

export default component.exports